import React, { useContext, useEffect, useState } from 'react'
import { Content, LoadingMessage } from './style'
import OrdersTable from './OrdersTable'
import LoadMoreButton from '../../../components/Orders/LoadMoreButton'
import LoadingGif from '../../../assets/loading'
import LoadingComponent from '../../../components/LoadingComponent'
import { LeftSide, SectionName, SubHeaderContainer } from '../../../components/subheader-style'

const OrdersSubHeader:React.FC = () => {
  return(
    <SubHeaderContainer>
    <LeftSide>
      <SectionName>Pedidos</SectionName>
    </LeftSide>
  </SubHeaderContainer>
  )
}

const OrdersContent = () => {
  
  return (
    <>
      <OrdersSubHeader />
      <Content>
        <OrdersTable/>
        <LoadMoreButton/>
      </Content>
    </>
  )
}
export default OrdersContent
